export enum LanguagesEnum {
    'UK' = 'uk',
    'EN' = 'en',
}
